import { ApronStatus } from '../../enum';
import { MerchantDto } from "../merchant.dto";
import { EmployeeDto } from "../employee.dto";

export class ApronDto {
  id?: number;
  merchantId?: number;
  operatorEmployeeId?: number;
  managerEmployeeId?: number;
  floatAmount?: number;
  cashFromSalesAmount?: number;
  totalDroppedAmount?: number;
  expectedAmount?: number;
  countedAmount?: number;
  cashDropsNumber?: number;
  cashExpected?: number
  status?: ApronStatus;
  currencyId?: number;
  deviceId?: number;
  startDate?: Date;
  endDate?: Date;
  note?: string;
  lastModifiedUserId?: number;
  createdDate?: Date;
  modifiedDate?: Date;
  version?: number;
  operator: EmployeeDto | null;
  merchant: MerchantDto | null;
}